import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Brand from './Brand';
import { useAuthStatus } from '../../hooks/useAuthStatus';

const PublicNav = () => {
  const [open, setOpen] = useState(false);
  const isLoggedIn = useAuthStatus();

  // Verrouiller le scroll + Escape quand le tiroir est ouvert
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <>
      <header className="public-nav">
        <Brand />
        <nav className="desktop-nav">
          <a href="#concept">Concept</a>
          <a href="#ecosystem">Écosystème</a>
          <a href="#pricing">Offres</a>
        </nav>
        <div className="nav-actions">
          {isLoggedIn ? (
            <Link to="/dashboard" className="button button-dark">
              <i className="fa-solid fa-table-columns" style={{ fontSize: '.7rem' }} /> Mon studio
            </Link>
          ) : (
            <>
              <Link to="/login" className="nav-login">Se connecter</Link>
              <Link to="/register" className="button button-dark">
                <i className="fa-solid fa-bolt" style={{ fontSize: '.7rem' }} /> Lancer mon projet
              </Link>
            </>
          )}
          <button aria-label="Ouvrir le menu" className="icon-button" onClick={() => setOpen(true)}>
            <i className="fa-solid fa-bars" />
          </button>
        </div>
      </header>
      {open && (
        <div className="mobile-drawer-backdrop" onClick={() => setOpen(false)}>
          <aside className="mobile-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="drawer-head">
              <Brand />
              <button aria-label="Fermer le menu" className="icon-button" onClick={() => setOpen(false)}>
                <i className="fa-solid fa-xmark" />
              </button>
            </div>
            <a href="#concept" onClick={() => setOpen(false)}>Concept</a>
            <a href="#ecosystem" onClick={() => setOpen(false)}>Écosystème</a>
            <a href="#pricing" onClick={() => setOpen(false)}>Offres</a>
            {isLoggedIn ? (
              <Link to="/dashboard" className="button button-dark" onClick={() => setOpen(false)}>
                Mon studio <i className="fa-solid fa-arrow-right" style={{ fontSize: '.7rem' }} />
              </Link>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)}>
                  Se connecter <i className="fa-solid fa-arrow-right" style={{ fontSize: '.7rem' }} />
                </Link>
                <Link to="/register" className="button button-dark" onClick={() => setOpen(false)}>
                  Lancer mon projet
                </Link>
              </>
            )}
          </aside>
        </div>
      )}
    </>
  );
};

export default PublicNav;
